(() => {
  'use strict';
  if (window.sonixCommerceInitialized) return;
  window.sonixCommerceInitialized = true;

  const updateVariant = (select) => {
    const section = select.closest('[data-product-section]');
    const option = select.selectedOptions[0];
    if (!section || !option || !option.value) return;

    const available = option.dataset.available === 'true';
    const button = section.querySelector('[data-add-button]');
    const label = section.querySelector('[data-add-label]');
    const price = section.querySelector('[data-variant-price]');
    const compare = section.querySelector('[data-variant-compare]');
    const sale = section.querySelector('[data-variant-sale]');
    const status = section.querySelector('[data-variant-status]');
    if (button) button.disabled = !available;
    if (label) label.textContent = available ? 'Add to cart' : 'Sold out';
    if (price) price.textContent = option.dataset.price || '';
    if (compare) {
      compare.textContent = option.dataset.compare || '';
      compare.hidden = !option.dataset.compare;
    }
    if (sale) sale.hidden = !option.dataset.compare;
    if (status) status.textContent = available ? '' : 'This option is currently sold out.';

    const quantity = section.querySelector('[data-product-quantity]');
    if (quantity) {
      const minimum = Number(option.dataset.min) || 1;
      const increment = Number(option.dataset.step) || 1;
      quantity.min = String(minimum);
      quantity.step = String(increment);
      if (option.dataset.max) quantity.max = option.dataset.max;
      else quantity.removeAttribute('max');
      // A new variant can have different quantity rules.
      quantity.value = String(minimum);
    }

    const productArt = section.querySelector('[data-product-art]');
    const variantArt = section.querySelector('[data-variant-art]');
    const variantImage = variantArt?.querySelector('img');
    if (variantArt && variantImage && productArt) {
      const source = option.dataset.image;
      if (source) {
        variantImage.removeAttribute('srcset');
        variantImage.removeAttribute('sizes');
        variantImage.src = source;
        variantImage.alt = option.dataset.imageAlt || '';
        variantImage.hidden = false;
        variantArt.hidden = false;
        productArt.hidden = true;
      } else {
        variantArt.hidden = true;
        productArt.hidden = false;
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.delete('option_values');
    url.searchParams.set('variant', option.value);
    window.history.replaceState({}, '', url);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('[data-variant-select]')) updateVariant(event.target);
  });

  // Keep comparisons clear: starting one demo pauses the other.
  document.addEventListener('play', (event) => {
    if (!(event.target instanceof HTMLAudioElement) || !event.target.matches('[data-sonix-audio]')) return;
    document.querySelectorAll('[data-sonix-audio]').forEach((audio) => {
      if (audio !== event.target) audio.pause();
    });
  }, true);
})();
